import { tableCellClasses } from '@mui/material'

/** Shared list-table tokens so Direct / Factored / Carrier match Vendor. */
export const LIST_TABLE_EVEN_ROW_BG = '#FAFAFA'

export const listTableHeaderCellStyles = {
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#FFFFFF',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1.4,
    padding: '12px 16px',
    zIndex: 2,
    whiteSpace: 'nowrap' as const,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
}

export const listTableBodyCellStyles = {
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    lineHeight: 1.4,
    padding: '12px 16px',
    color: 'rgba(0, 0, 0, 0.87)',
    verticalAlign: 'middle' as const,
  },
}

export const listTableEvenRowSx = {
  '&:nth-of-type(even)': {
    backgroundColor: LIST_TABLE_EVEN_ROW_BG,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}

export const listTableToolbarSx = {
  py: 2,
  px: 2,
  borderBottom: 1,
  borderColor: 'divider',
  bgcolor: 'background.paper',
  flexShrink: 0,
}

export const listTableSx = {
  tableLayout: 'fixed' as const,
  minWidth: 960,
}

export const listPrimaryTextSx = {
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.4,
  color: 'text.primary',
}

export const listSecondaryTextSx = {
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.35,
  color: 'text.secondary',
}
